import { NavLink } from 'react-router-dom'
import { Settings2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const sections = [
  { path: 'config', label: 'Config', Icon: Settings2 },
]

export function PromptSectionsNav() {
  return (
    <nav className="w-[220px] shrink-0 rounded-2xl border border-border bg-card p-3" aria-label="Prompt sections" data-testid="prompt-sections-nav">
      <p className="px-2 pb-2 text-sm font-bold leading-[1.6] tracking-[0.015em] text-foreground">Prompt sections</p>
      <ul className="space-y-1">
        {sections.map(({ path, label, Icon }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-lg px-2 py-2 text-sm transition-colors',
                  isActive ? 'bg-primary font-semibold text-primary-foreground' : 'text-foreground hover:bg-muted',
                )
              }
              data-testid={`prompt-section-link-${path}`}
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
